export default __webpack_public_path__ + "2f6772543ca1c44d3f92484f32260ace.ico";